export default "__VITE_ASSET__xDzqLGQn__"